(() => {
    'use strict';

    const module = 
        angular
            .module('uwAgenda.users')
            .controller(
                'EditUserController', [
                    '$translate',
                    '$scope',
                    '$rootScope',
                    '$state',
                    '$stateParams',
                    '$filter',
                    'Alert',
                    'ContactInfo',
                    'user',
                    'languages',
                    'roles',
                    'licences',
                    'AdministrationService',
                    'HelperService',
                    'UserService',
                    'User',
                    'IVRTime',
                    'AdditionalInfoField',
                    'SharedAgendaService',
                    'mainUserIds',
                    'RegistrationService',
                    '$window',
                    'StartPageEnum',
                    'RoleType',
                    'UserFilterService',
                    'Weekday',
                    'DownloadService',
                    'UserDetailService',
                    'UserContactInfoTypeEnum',
                    'AppConfig',
                    EditUserControllerFn]);

    function EditUserControllerFn(
        $translate,
        $scope,
        $rootScope,
        $state,
        $stateParams,
        $filter,
        Alert,
        ContactInfo,
        user,
        languages,
        roles,
        licences,
        AdministrationService,
        HelperService,
        UserService,
        User,
        IVRTime,
        AdditionalInfoField,
        SharedAgendaService,
        mainUserIds,
        RegistrationService,
        $window,
        StartPageEnum,
        RoleType,
        UserFilterService,
        Weekday,
        DownloadService,
        UserDetailService,
        UserContactInfoTypeEnum,
        AppConfig) {
        const vm = this;
        vm.ncyLabel = 'new';
        vm.user = {};
        vm.isRingfoonAdmin = false;
        vm.isLoginViaCorilusPassportToggleEnabeled = false;
        vm.showMedical = false;
        vm.medicaldisciplines = [];
        vm.licences = [];
        vm.languages = [];
        vm.groupPractices = [];
        vm.locations = [];
        vm.selectedNewContactInfoType = null;
        vm.startPageEnumList = [
            StartPageEnum.UrgentTodo,
            StartPageEnum.DayTask,
            StartPageEnum.User,
            StartPageEnum.AgendaDay,
            StartPageEnum.AgendaWeek,
            StartPageEnum.AgendaSettings
        ];
        vm.contactIsMainUser = false;
        vm.contactIsRingfoonUser = false;
        vm.contactIsColleague = false;
        vm.isCurrentOwner = false;
        vm.selectedGroupPractice = null;
        vm.selectedLocation = null;
        vm.selectedRoles = [];
        vm.roles = roles; // TODO: make sure in the backend only the allowed roles are selectable
        vm.isCurrentAgendaMine = false;

        activate();
        
        //Function to determine if we should exclude the 'colleague' role
        vm.isExcludedRole = function(role) {
            return role.id === RoleType.Colleague.value;
        };
        
        vm.overwritingNationalNumber = false;

        vm.overwriteNationalNumber = () => {
            vm.overwritingNationalNumber = true;
        };
        
        vm.showNnInfo = () => {
            HelperService.showInfoModal(
                'national_number_info_header',
                'national_number_info');
        };

        vm.addNewAdditionalInfo = function () {
            const info = new AdditionalInfoField();
            vm.user.additionalInfos.push(info);
        };
        
        vm.sendForgotPasswordEmail = function () {
            const userEmail = vm.user.mainEmail;

            if (!userEmail) {
                Alert.danger($translate.instant('no_email_found_for_password_reset'));
                return;
            }

            let agendaOwnerId = null;
            // if the main user himself sends the forgot password email, set his id (agendaOwnerId)
            // as the sender of the email, so that the email appears in his email overview
            if ($rootScope.isMainuser) {
                agendaOwnerId = SharedAgendaService.currentUser().id;
            }

            RegistrationService
                .sendForgotPasswordEmail(userEmail, vm.user.userName, agendaOwnerId)
                .then(function (result) {
                    Alert.success($translate.instant('password_reset_email_sent_to', {email: userEmail}));                    
            });
        };

        vm.checkPasswordsMatch = function(form, password, passwordRepeated) {
            const passwordsEqual = password === passwordRepeated;
            form.$setValidity('password_repeat', passwordsEqual);

            return passwordsEqual;
        };

        vm.save = function () {
            if (vm.moreThanOneEmail()) {
                Alert.error('single_email_allowed');
                return;
            }
            
            if (moreThanOneInCommunication()) {
                Alert.error('single_in_communication');
                return;
            }
            
            vm.overwritingNationalNumber = false;
            
            let user = new User();

            if (!vm.user.id &&
                vm.user.decryptedPassword !== vm.user.password_repeat) {
                return;
            }

            angular.copy(vm.user, user);
            user.prepareForSave(vm.selectedRoles);

            if (user.id) {
                UserService.update(user.id, SharedAgendaService.currentUser().id, SharedAgendaService.data.currentAgenda.id, user)
                           .then(function (savedUser) {
                    Alert.success($translate.instant('user_successfully_saved'));
                    user = null;

                    reloadAfterUpdate(savedUser);
                    
                    $state.go('Home.UserDetail.Profile'); 
                });
            } else {
                UserService.save(SharedAgendaService.currentUser().id, SharedAgendaService.data.currentAgenda.id, user)
                           .then(function (savedUser) {
                    Alert.success($translate.instant('user_successfully_created'));
                    vm.user.id = savedUser.id;
                    user = null;

                    reloadAfterUpdate(savedUser);
                    
                    $state.go('Home.UserDetail.Profile');
                });
            }
        };

        vm.moreThanOneEmail = () => {
            return emailsInContactInfos() > 1;
        };
        
        function moreThanOneInCommunication() {
            let emailCount = 0;
            let numberCount = 0;
            for (let i = 0; i < vm.user.contactInfos.length; i++) {
                let contactInfo = vm.user.contactInfos[i];
                let contactInfoType = contactInfo.userContactInfoType.type;
                let contactInfoInCommunication = contactInfo.showInCommunication;
                if (contactInfoInCommunication) {
                    if (contactInfoType === UserContactInfoTypeEnum.Email.value) {
                        emailCount++;
                    } else if (contactInfoType === UserContactInfoTypeEnum.Phone.value || contactInfoType === UserContactInfoTypeEnum.Mobile.value) {
                        numberCount++;
                    }
                }
            }
            return emailCount > 1 || numberCount > 1;
        }
        
        function emailsInContactInfos() {
            let count = 0;
            for (let i = 0; i < vm.user.contactInfos.length; i++) {
                if (vm.user.contactInfos[i].userContactInfoType.type === UserContactInfoTypeEnum.Email.value) {
                    count++;
                }
            }
            return count;
        }

        vm.abort = function () {
            user = null;
            $state.go('Home.Users', { all: false });
        };

        vm.selectStartPage = function (page) {
            vm.user.detail.vmStartPage = page;
        };

        vm.selectLanguage = function (language) {
            vm.user.language = language;
        };

        vm.selectLicence = function (licence) {
            vm.user.licence = licence;
        };
        
        vm.selectRole = function (role) {
            vm.selectedRoles = [{
                fK_Role: role.id,
                role: role,
                isReadonlyForCurrentUser: role.isReadonlyForCurrentUser
            }];

            updateRoleDependentVisibility();
        };

        vm.selectGroupPractice = function(groupPractice) {
            vm.selectedGroupPractice = groupPractice;
            vm.user.fK_GroupPractice = groupPractice.id;
            
            vm.user.fK_InternalLocation = null;
            vm.selectedLocation = null;

            loadGroupPracticeInternalLocations(groupPractice.id);
        };

        vm.selectLocation = function(location) {
            vm.selectedLocation = location;
            vm.user.fK_InternalLocation = location.id;
        };

        function loadMedicalDisciplines(languageId) {
            if (!vm.contactIsMainUser) {
                return;
            }

            if (languageId) {
                vm.showMedical = false;
                // because med dis is dependent on the language of the user -> loading is here 
                AdministrationService.medicaldisciplines(languageId).then(function (result) {
                    vm.medicaldisciplines = result;
                    vm.showMedical = true;
                }, function (error) {
                    vm.showMedical = false;
                });
            } 
        }

        function loadGroupPracticeInternalLocations(groupPracticeId) {
            vm.locations = [];
            return AdministrationService.internalLocations(groupPracticeId, true)
                .then(function(locations) {
                    vm.locations = locations;
                    return locations;
                });
        }

        vm.unlinkCorilusPassportIdClickEvent = function () {
            UserService.removeCorilusPersonId(vm.user.id)
              .then(function() {
                  Alert.success($translate.instant('corilus_passport_unlink_success'));
                  vm.user.hasCorilusPassportLinked = false;
                  vm.user.isSecureLoginRequired = false;
              })
              .catch(function() {
                  Alert.warning($translate.instant('corilus_passport_unlink_fail'));
              });
        };
        
        function activate() {
            SharedAgendaService.block();

            vm.isRingfoonAdmin = $rootScope.isRingfoonAdmin;
            vm.form = UserDetailService.data.form;
            
            vm.isLoginViaCorilusPassportToggleEnabeled = $rootScope.isRingfoonAdmin;

            if (user === null || typeof user === 'undefined') {
                vm.user = new User();
                vm.ncyLabel = 'new';
            } else {
                vm.user = new User();
                vm.user.extend(user);
                vm.ncyLabel = 'edit';
                vm.originalUsername = vm.user.userName;

                vm.form.personal = false;
                vm.form.account = false;

                let currentOwnerId = SharedAgendaService.data && SharedAgendaService.data.currentAgenda.owner ? SharedAgendaService.data.currentAgenda.owner.id : null;
                vm.isCurrentOwner = currentOwnerId === vm.user.id;
            }

            vm.languages = languages;
            vm.licences = licences;
            vm.groupPractices = UserDetailService.data.groupPractices;
            vm.isCurrentAgendaMine = vm.user.id === SharedAgendaService.getLoggedInUserData().id;

            vm.selectedGroupPractice = vm.groupPractices.filter(function(gp) {
                return gp.id === vm.user.fK_GroupPractice;
            })[0];

            if (vm.user.fK_GroupPractice) {
                loadGroupPracticeInternalLocations(vm.user.fK_GroupPractice)
                    .then(function(locations) {
                        vm.selectedLocation = locations.filter(function(loc) {
                            return loc.id === vm.user.fK_InternalLocation;
                        })[0];
                    });
            }
            
            setStartPage();
            setLicence();
            setTimes();
            setContactInfos();
            
            setCurrentRoleWithLowestOrder();

            updateRoleDependentVisibility();
            
            listen();
        }
        
        function updateRoleDependentVisibility() {
            vm.contactIsMainUser = false;
            vm.contactIsRingfoonUser = false;
            vm.contactIsColleague = false;

            if (vm.selectedRoles && vm.selectedRoles.length > 0) {
                for (let i = 0; i < vm.selectedRoles.length; i++) {
                    const roleType = vm.selectedRoles[i].role.type;

                    if (roleType === RoleType.MainUser.value) {
                        vm.contactIsMainUser = true;
                    }

                    if (roleType === RoleType.Colleague.value) {
                        vm.contactIsColleague = true;
                    }

                    if (roleType === RoleType.RingfoonAdmin.value || roleType === RoleType.RingfoonOperatorAdmin.value || roleType === RoleType.RingfoonOperatorRestricted.value) {
                        vm.contactIsRingfoonUser = true;
                    }
                }
            }

            // reload medical disciplines - dependent on user role
            loadMedicalDisciplines(vm.user.fK_Language);

            // main user must have a licence, so if user gets the role mainuser we assign the first licence as default
            // if user looses the role mainuser we also remove his licence
            if (vm.contactIsMainUser === true && !vm.user.licence) {
                vm.user.licence = vm.licences[0];
                vm.user.fK_Licence = vm.user.licence.id;
            }
            else if (vm.contactIsMainUser === false && vm.user.licence) {
                vm.user.licence = null;
                vm.user.fK_Licence = null;
            }
        }
        
        function setCurrentRoleWithLowestOrder() {
            if (vm.user.userRoles && vm.user.userRoles.length > 0) {
                const roleWithLowestOrder = vm.user.userRoles
                    .filter(role => role.deleted === false)
                    .sort((a, b) => a.order < b.order)[0];
                vm.selectedRoles = [roleWithLowestOrder];
            } else {
                const patientRole = roles.find(role => role.type === RoleType.Patient.value);
                vm.selectedRoles = [{
                    fK_Role: patientRole.id,
                    role: patientRole,
                    isReadonlyForCurrentUser: patientRole.isReadonlyForCurrentUser
                }];
            }
        }
        
        function setStartPage() {
            if (typeof vm.user.detail.startPage !== 'undefined' && vm.user.detail.startPage !== null) {
                vm.user.detail.vmStartPage = $filter('filter')(vm.startPageEnumList, { value: vm.user.detail.startPage }, true)[0];
            }            
        }
        
        function setLicence() {
            if (typeof vm.user.fK_Licence !== 'undefined' && vm.user.fK_Licence !== null) {
                vm.user.licence = $filter('filter')(vm.licences, { id: vm.user.fK_Licence }, true)[0];
            }
        }
        
        function setTimes() {
            if (typeof vm.user.ivrTimes === 'undefined' || vm.user.ivrTimes === null || vm.user.ivrTimes.length <= 0) {
                const times = [];
                angular.forEach(Weekday, function (weekday) {
                    if (weekday !== Weekday.Holiday) {
                        const time = new IVRTime(weekday);

                        times.push(time);
                    }
                });
                vm.user.ivrTimes = times;
            }
        }
        
        function setLanguages() {
            vm.languages.forEach(function (lang) {
                if (lang.id === vm.user.fK_Language) {
                    vm.user.language = lang;
                }
            });
        }
        
        function setContactInfos() {
            const contactInfos = [];
            if (typeof vm.user.contactInfos !== 'undefined' && vm.user.contactInfos !== null) {
                let j = 0;
                const len = vm.user.contactInfos.length;
                for (j = 0; j < len; j++) {
                    const ci = new ContactInfo();
                    ci.extend(vm.user.contactInfos[j]);
                    contactInfos.push(ci);
                }
            }
            vm.user.contactInfos = contactInfos;
        }
        
        function reloadAfterUpdate(user) {
            SharedAgendaService.block();

            vm.user = new User();
            vm.user.extend(user);
            vm.ncyLabel = 'edit';

            vm.form.personal = false;
            vm.form.account = false;
            
            setLanguages();

            setStartPage();
            setLicence();
            setTimes();
            setContactInfos();
            
            updateRoleDependentVisibility();
        }
        
        function listen() {
            let watchUnbinder = $scope.$watch(function () {
                return vm.user.language;
            }, function (newVal) {
                if (newVal) {
                    loadMedicalDisciplines(newVal.id);
                }
            });

            $scope.$on("$destroy", function () {
                watchUnbinder();
                watchUnbinder = null;
            });
        }
    }
})();
